<template>
  <div class="table_box">
    <el-table
      ref="tableRef"
      :summary-method="getSummaries"
      show-summary
      size="small"
      :data="data"
      border
      style="width:100%"
      :height="max"
      class="tabone_sty"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height: '40px'}"
    >
      <el-table-column width="40" align="center" fixed="left" prop="aaaa">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column fixed="left" label="操作" prop="aaaa" align="center" width="80">
        <template slot-scope="scope">
          <el-button @click.native.prevent="addRow(scope.$index)" type="text" size="small">新增</el-button>
          <el-button @click.native.prevent="deleteRow(scope.$index)" type="text" size="small">移除</el-button>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ConfigData">
        <!-- <el-table-column
          width="150"
          align="center"
          :label="item.Rename"
          :prop="item.Key"
          :key="index"
          v-if="item.Name == '账户编号' && item.Show == true"
          fixed="left"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <el-input
                size="mini"
                type="text"
                class="input_sty"
                :value="scope.row[item.Key]"
                placeholder
                @dblclick.native="dblClick(scope.$index)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          align="center"
          :label="item.Rename"
          :prop="item.Key"
          :key="index"
          v-if="item.Name == '账户名称' && item.Show == true"
          fixed="left"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <el-input
                size="mini"
                type="text"
                class="input_sty"
                :value="scope.row[item.Key]"
                placeholder
                @dblclick.native="dblClick(scope.$index)"
              ></el-input>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column :label="item.Rename" :prop="item.Key" align="center" :key="index" v-if="item.Show == true">
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <el-input
                size="mini"
                v-if="item.Key == 'AtypeId'||item.Key == 'FullName'"
                type="text"
                class="input_sty"
                :value="scope.row[item.Key]"
                placeholder
                @dblclick.native="dblClick(scope.$index)"
              ></el-input>
              <el-input
                size="mini"
                v-else-if="scope.row.FullName!==''&& scope.row.AtypeId !== '' && item.Key=='Total'"
                type="text"
                class="input_sty"
                v-model="scope.row[item.Key]"
                @focus="inputFocus($event)"
                @input="scope.row[item.Key]=scope.row[item.Key].replace(/^[^\-\d]*([\-\d]?\d*(?:\.\d{0,6})?).*$/g, '$1');"
              ></el-input>
              <!-- @input="scope.row[item.Key]=scope.row[item.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1');"/^\D*\-?[1-9]\d*.?\d*$/g -->
              <el-input
                size="mini"
                v-else-if="scope.row.FullName!==''&& scope.row.AtypeId !== ''&& item.Key=='Memo'"
                type="text"
                class="input_sty"
                v-model="scope.row[item.Key]"
                @focus="inputFocus($event)"
                @input="scope.row[item.Key]"
              ></el-input>
              <div v-else class="only_show_div">{{scope.row[item.Key]}}</div>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- table表格配置弹出框 -->
    <TableConfigDialog :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs"  v-on="$listeners" @restoreDefault="restoreDefault"/>
    <!-- 银行收索弹出框 -->
    <SearchBankDialog :show.sync="seaechbankShow"  :searchData="searchData"  @dbclickRow="chooseGoodsBack"  v-bind="$attrs"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false, //是否启用扫码枪录入商品
      tableConfigShow: false, //配置项弹出框是否显示
      seaechbankShow: false, //银行选择弹出框是否显示
      ConfigData: this.tableConfigData, //table配置项数据
      rowIndex: -1, //点击的是第几行
      data:this.tableData,//表格数据项
      // jparam:this.goodsParams,
      // 银行账户弹出框所需参数
      searchData: { title: "银行账户",url1: "",url2: "/index/Settings/get_other",url3: "/index/Settings/search_other", type:4,interface: 6 } //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
    };
  },
  props: {
    max: String,
    // Namecommodity:String,
    tableData: Array,
    tableConfigData: Array, //table配置项数据
    // goodsParams: Object //用于传递给商品弹出框列表
  },
  methods: {
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    },
    // 传递数据给saleorder页面
    chooseGoodsBack(data) {
      // 拼接Total、Memo两个字段
      let newObj =  Object.assign({Total: '',Memo :'',}, data);
      this.$emit("chooseGoodsBack", newObj, this.rowIndex);
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // console.log(columns,param);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        
        const values = data.map(item => {
          if (
            column.property == "Qty" ||
            column.property == "Total" ||
            column.property == "DiscountTotal" ||
            column.property == "WithTaxTotal"
          ) {
            if (Number(item[column.property]) != "undefined") {
              return Number(item[column.property]);
            }
          }
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = this.sum(values);
          sums[index] += "";
        } else {
          // sums[index] = 'N/A';
        }
      });
      // console.log('///',sums);
      return sums;
    },
    // 移除某一行
    deleteRow(index) {
      this.$emit("deleteRow", index);
    },
    // 新增某一行
    addRow(index) {
      this.$emit("addback", index);
    },
    // 双击列表某一行
    dblClick(index) {
      this.rowIndex = index;
      this.seaechbankShow = true;
    },
    //点击图标事件
    clickIcon() {
      this.tableConfigShow = true;
      // this.$emit('clickIcon')
    },
    // 累加数组中的number
    sum(arr) {
        var s = 0;
        for (var i=arr.length-1; i>=0; i--) {
          if(isNaN(arr[i])){
            arr[i] = 0;
          }
          s += arr[i];
        }
        return Number(s).toFixed(2);
    },
    // 恢复默认回调数据
    restoreDefault(data){
      this.ConfigData = data;
    },
  },
  watch: {
    tableConfigData: {
      handler(newValue, oldValue) {
        this.ConfigData = newValue;
        this.data = this.tableData;
        this.$nextTick(()=>{
          this.$refs.tableRef.doLayout();
        })
      },
      deep: true
    },
    tableData:{
      handler(newValue, oldValue) {
        this.data = this.tableData;
        // this.$nextTick(()=>{
        //   this.$refs.tableRef.doLayout();
        // })
      },
      deep: true
    },
  },
  computed: {},
  mounted() {
    // console.log(this.tableConfigData);
  }
};
</script>
<style lang="less">
// 引入样式
@import "./BankTable.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/BankTable/BankTable.vue